import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from "../components/common/react-notifications";
import FieldError from "../components/FieldError";
import Api from "../services/Api";
import Select from "react-select";
import {isEqual} from 'lodash';


class PairZonesManageForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zoneOptions: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/zones');
      this.setState({
        zoneOptions: data.rows.map(item => ({label: item.name, value: item.id})),
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  updatePair = async values => {
    const {t, pair, afterSubmit} = this.props;
    const symbols = pair.name.split('/');
    try {
      await Api.invoke(
        'PATCH',
        `/v2/admin-ui/pairs/${symbols[0]}%2F${symbols[1]}`,
        {
          zones: values.zones.map(item => item.value),
        },
      );
      NotificationManager.success(t('Pair {{name}} updated successfully', {name: pair.name}), t('Message'));
      afterSubmit();
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
      closeMenuOnSelect={false}
    />
  );

  render() {
    const {t, pair} = this.props;
    return(
      <FinalForm
        initialValues={{
          zones: pair ? pair.zones.map(item => ({label: item.name, value: item.id})) : undefined,
        }}
        onSubmit={this.updatePair}
        render={({handleSubmit, submitting, hasValidationErrors, values, initialValues}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-4">
                <Col>
                  <span>
                   {t('Zones')}
                  </span>
                  <Field
                    name="zones"
                    component={this.ReactSelectAdapter}
                    options={this.state.zoneOptions}
                  />
                  <FieldError name='zones' />
                </Col>
              </Row>
              <Row className='mt-5'>
                <Col>
                  <LoaderButton
                    color="success"
                    className="text-center"
                    loading={submitting}
                    onClick={handleSubmit}
                    style={{minWidth: '100px'}}
                    disabled={hasValidationErrors || submitting || isEqual(values, initialValues)}>
                    {t('Update')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(PairZonesManageForm);
